/* My Acre collection faceting. No app, no Search & Discovery dependency.
   Loaded by sections/ma-collection.liquid.

   Why it works this way:
   Liquid exposes at most 50 products of a collection at a time, and this store has no Search &
   Discovery app, so collection.filters only ever returns Product type. templates/collection.facets
   emits the whole collection as compact JSON, 50 per request. This fetches it on idle, builds
   Brand / Type / Price / Availability facets, then filters and sorts in the browser.

   SEO: the unfiltered page is never touched. The server-rendered grid, its pagination links and
   the canonical stay exactly as Shopify wrote them, so what Google crawls is unchanged. Facet
   state lives in the URL hash, which is never sent to the server and never indexed. The grid is
   only taken over once a facet is actually applied. */
(function () {
  var root = document.querySelector('.ma-coll');
  if (!root) return;
  var form = root.querySelector('[data-macf-form]');
  var grid = root.querySelector('.mac-grid');
  var pager = root.querySelector('.mac-pag');
  if (!form || !grid) return;

  var LEVEL = root.getAttribute('data-filter-level') || 'full';
  if (LEVEL === 'minimal') return;
  var MAXG = LEVEL === 'standard' ? 2 : 4;

  var handle = (root.getAttribute('data-collection') || '').trim();
  if (!handle) return;

  var idx = null, loading = null, serverGrid = grid.innerHTML;
  var groupsEl = form.querySelector('.macf-groups');
  var countEl = form.querySelector('[data-macf-count]');
  var activeWrap = null;
  /* The server-rendered total. Used to bust the sessionStorage cache when the catalogue changes. */
  var EXPECTED = parseInt(((countEl || {}).textContent || '').replace(/\D+/g, ''), 10) || 0;

  var money = function (c) {
    var s = (c / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  };

  var BANDS = [
    { k: '0-500', l: 'Under $500', lo: 0, hi: 50000 },
    { k: '500-1000', l: '$500 to $1,000', lo: 50000, hi: 100000 },
    { k: '1000-2500', l: '$1,000 to $2,500', lo: 100000, hi: 250000 },
    { k: '2500-5000', l: '$2,500 to $5,000', lo: 250000, hi: 500000 },
    { k: '5000+', l: '$5,000 and above', lo: 500000, hi: Infinity }
  ];

  /* Sequential, guarded, cached.
     Parallel page fetches tripped Shopify's rate limiter (429), and a single non-JSON response
     rejected Promise.all, which threw away the whole index. Now: one page at a time, each page
     parsed in a try/catch, one retry on 429, and the result cached in sessionStorage so a repeat
     visit or a back-navigation costs nothing. */
  var CACHE_KEY = 'macf:' + handle;

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      return (o && o.t === EXPECTED && Array.isArray(o.i)) ? o.i : null;
    } catch (e) { return null; }
  }
  function writeCache(items) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: EXPECTED, i: items })); } catch (e) {}
  }

  function getPage(n, retried) {
    return fetch('/collections/' + handle + '?view=facets&page=' + n, { credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 429 && !retried) {
          return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return getPage(n, true); });
        }
        if (!r.ok) return null;
        return r.text().then(function (txt) {
          try { return JSON.parse(txt); } catch (e) { return null; }
        });
      })
      .catch(function () { return null; });
  }

  function load() {
    if (idx) return Promise.resolve(idx);
    if (loading) return loading;
    var cached = readCache();
    if (cached) { idx = cached; return Promise.resolve(idx); }

    loading = getPage(1).then(function (first) {
      if (!first || !first.items) { loading = null; return null; }
      var all = first.items.slice();
      var chain = Promise.resolve();
      for (var p = 2; p <= first.pages; p++) {
        (function (n) {
          chain = chain.then(function () {
            return getPage(n).then(function (d) { if (d && d.items) all = all.concat(d.items); });
          });
        })(p);
      }
      return chain.then(function () {
        idx = all;
        writeCache(all);
        return idx;
      });
    }).catch(function () { idx = null; loading = null; return null; });
    return loading;
  }

  function facets(items) {
    var by = { v: {}, y: {}, price: {}, avail: 0 };
    items.forEach(function (it) {
      if (it.v) by.v[it.v] = (by.v[it.v] || 0) + 1;
      if (it.y) by.y[it.y] = (by.y[it.y] || 0) + 1;
      for (var i = 0; i < BANDS.length && !it.q; i++) {
        if (it.p >= BANDS[i].lo && it.p < BANDS[i].hi) { by.price[BANDS[i].k] = (by.price[BANDS[i].k] || 0) + 1; break; }
      }
      if (it.a) by.avail++;
    });
    var out = [];
    var mk = function (id, label, pairs) {
      pairs = pairs.filter(function (p) { return p[1] > 0; });
      if (pairs.length < 2) return;
      pairs.sort(function (a, b) { return b[1] - a[1] || a[0].localeCompare(b[0]); });
      out.push({ id: id, label: label, values: pairs });
    };
    mk('brand', 'Brand', Object.keys(by.v).map(function (k) { return [k, by.v[k]]; }));
    mk('type', 'Product type', Object.keys(by.y).map(function (k) { return [k, by.y[k]]; }));
    var pr = BANDS.filter(function (b) { return by.price[b.k]; }).map(function (b) { return [b.l, by.price[b.k]]; });
    if (pr.length >= 2) out.push({ id: 'price', label: 'Price', values: pr });
    if (by.avail > 0 && by.avail < items.length) out.push({ id: 'avail', label: 'Availability', values: [['In stock', by.avail]] });
    return out.slice(0, MAXG);
  }

  function state() {
    var h = (location.hash || '').replace(/^#/, '');
    var s = { brand: [], type: [], price: [], avail: [] };
    if (!h) return s;
    h.split('&').forEach(function (kv) {
      var i = kv.indexOf('=');
      if (i < 0) return;
      var k = kv.slice(0, i), v = decodeURIComponent(kv.slice(i + 1).replace(/\+/g, ' '));
      if (s[k]) s[k].push(v);
    });
    return s;
  }
  function setState(s) {
    var parts = [];
    Object.keys(s).forEach(function (k) {
      s[k].forEach(function (v) { parts.push(k + '=' + encodeURIComponent(v)); });
    });
    var h = parts.join('&');
    if (h) { history.replaceState(null, '', '#' + h); }
    else if (location.hash) { history.replaceState(null, '', location.pathname + location.search); }
  }
  function anyActive(s) {
    return s.brand.length || s.type.length || s.price.length || s.avail.length;
  }

  function match(it, s) {
    if (s.brand.length && s.brand.indexOf(it.v) < 0) return false;
    if (s.type.length && s.type.indexOf(it.y) < 0) return false;
    if (s.avail.length && !it.a) return false;
    if (s.price.length) {
      if (it.q) return false; /* price on request: never inside a price band */
      var hit = false;
      s.price.forEach(function (label) {
        var b = BANDS.filter(function (x) { return x.l === label; })[0];
        if (b && it.p >= b.lo && it.p < b.hi) hit = true;
      });
      if (!hit) return false;
    }
    return true;
  }


  /* 11 Sep 2026: same <img> the server renders in sections/ma-collection.liquid, so a filtered
     card and an unfiltered card look and load the same. The index carries the 600px URL; the
     other widths come from Shopify's width parameter on the same file. */
  /* 11 Sep 2026 (Claude): square centre crops from the CDN, matching the 1:1 cover frame, so
     landscape photos are no longer upscaled about 1.5x to fill it (same framing, sharper). */
  function sq(u, w) {
    return u.replace(/([?&])(height|crop)=[^&]*/g, '$1').replace(/[?&]+$/, '').replace(/&&+/g, '&').replace(/\?&/, '?')
      .replace(/([?&])width=\d+/, '$1width=' + w) + '&height=' + w + '&crop=center';
  }
  function cardImg(it) {
    var u = String(it.i), set = [300, 450, 600, 800].map(function (w) {
      return esc(sq(u, w)) + ' ' + w + 'w';
    }).join(', ');
    return '<img src="' + esc(sq(u, 600)) + '" srcset="' + set + '" sizes="(max-width: 520px) 47vw, (max-width: 1000px) 46vw, 420px"' +
      ' width="600" height="600" alt="' + esc(it.t) + '" loading="lazy" decoding="async">';
  }

  function card(it) {
    var meta = it.c > 1 ? '<span class="mac-fin">' + it.c + ' finishes</span>'
      : (it.n > 1 ? '<span class="mac-fin">' + it.n + ' options</span>' : '');
    var name = it.v && it.t.indexOf(it.v) === 0 ? it.t.slice(it.v.length).trim() : it.t;
    return '<a class="mac-pc" href="' + esc(it.u) + '" data-ga-item data-sku="' + esc(it.s || '') +
      '" data-name="' + esc(it.t) + '" data-price="' + (it.q ? '' : (it.p / 100)) + '">' +
      '<span class="mac-im">' + (it.i ? cardImg(it) : '') +
      (it.a ? '<span class="mac-stk"><i></i> In stock</span>' : '') + '</span>' +
      '<span class="mac-bd"><span class="mac-v">' + esc(it.v) + '</span>' +
      '<span class="mac-nm">' + esc(name) + '</span>' +
      '<span class="mac-meta"><span class="mac-pr">' + (it.q ? 'Price on request' : (it.f ? 'From ' : '') + money(it.p)) + '</span>' + meta + '</span>' +
      (it.v === 'Trendz' ? '<span class="mac-quote" role="link" tabindex="0" data-mac-quote="' + esc(it.u) + (String(it.u).indexOf('?') > -1 ? '&' : '?') + 'quote=1">Get a quote</span>' : '') +
      '<span class="mac-view">View product</span></span></a>';
  }

  function sortItems(list) {
    var sel = form.querySelector('[data-macf-sort]');
    var v = sel ? sel.value : 'manual';
    var l = list.slice();
    /* Price on request (q) has no price to rank by, so it always sorts last. */
    if (v === 'price-ascending') l.sort(function (a, b) { return (a.q - b.q) || (a.p - b.p); });
    else if (v === 'price-descending') l.sort(function (a, b) { return (a.q - b.q) || (b.p - a.p); });
    return l;
  }

  function renderActive(s, groups) {
    if (activeWrap) { activeWrap.parentNode.removeChild(activeWrap); activeWrap = null; }
    if (!anyActive(s)) return;
    var html = '';
    Object.keys(s).forEach(function (k) {
      s[k].forEach(function (v) {
        var g = groups.filter(function (x) { return x.id === k; })[0];
        html += '<button type="button" class="macf-chip" data-macf-off="' + k + '|' + esc(v) + '">' +
          esc(g ? g.label : k) + ': ' + esc(v) +
          ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      });
    });
    html += '<button type="button" class="macf-clear" data-macf-clearall>Clear all</button>';
    activeWrap = document.createElement('div');
    activeWrap.className = 'macf-active';
    activeWrap.innerHTML = html;
    form.appendChild(activeWrap);
    activeWrap.addEventListener('click', function (e) {
      var off = e.target.closest('[data-macf-off]');
      if (off) {
        var p = off.getAttribute('data-macf-off'), i = p.indexOf('|');
        var k = p.slice(0, i), v = p.slice(i + 1);
        var st = state();
        st[k] = st[k].filter(function (x) { return x !== v; });
        setState(st); apply(); return;
      }
      if (e.target.closest('[data-macf-clearall]')) {
        setState({ brand: [], type: [], price: [], avail: [] }); apply();
      }
    });
  }

  function apply() {
    var s = state();
    if (!idx) return;
    var groups = facets(idx);

    form.querySelectorAll('[data-macf-cb]').forEach(function (cb) {
      var k = cb.getAttribute('data-g'), v = cb.value;
      cb.checked = s[k] && s[k].indexOf(v) >= 0;
    });

    var none = root.querySelector('[data-macf-none]');

    if (!anyActive(s)) {
      grid.innerHTML = serverGrid;
      if (pager) pager.style.display = '';
      if (none) none.hidden = true;
      if (countEl) countEl.textContent = EXPECTED + ' product' + (EXPECTED === 1 ? '' : 's');
      renderActive(s, groups);
      updateBadges(s);
      return;
    }

    var list = sortItems(idx.filter(function (it) { return match(it, s); }));
    if (pager) pager.style.display = 'none';
    grid.innerHTML = list.length ? list.map(card).join('') : '';
    if (none) none.hidden = list.length > 0;
    if (countEl) countEl.textContent = list.length + ' product' + (list.length === 1 ? '' : 's');
    renderActive(s, groups);
    updateBadges(s);
  }

  function updateBadges(s) {
    form.querySelectorAll('[data-macf-pop]').forEach(function (pop) {
      var k = pop.getAttribute('data-g');
      var btn = pop.querySelector('[data-macf-toggle]');
      var old = btn.querySelector('.macf-n');
      if (old) old.parentNode.removeChild(old);
      var n = s[k] ? s[k].length : 0;
      if (n) {
        var b = document.createElement('span');
        b.className = 'macf-n'; b.textContent = n;
        btn.insertBefore(b, btn.querySelector('svg'));
      }
    });
    var openBtn = form.querySelector('[data-macf-open]');
    if (openBtn) {
      var mob = openBtn.querySelector('.macf-n');
      if (mob) mob.parentNode.removeChild(mob);
      var total = ['brand', 'type', 'price', 'avail'].reduce(function (a, k) { return a + (s[k] ? s[k].length : 0); }, 0);
      if (total) {
        var sp = document.createElement('span'); sp.className = 'macf-n'; sp.textContent = total;
        openBtn.appendChild(sp);
      }
    }
  }

  var built = false;
  function buildUI(groups) {
    if (!groupsEl) return;
    built = true;
    var s = state();
    var html = '';
    groups.forEach(function (g) {
      var n = (s[g.id] || []).length;
      html += '<div class="macf-pop" data-macf-pop data-g="' + g.id + '">' +
        '<button type="button" class="macf-btn" data-macf-toggle aria-expanded="false" aria-controls="macf-g-' + g.id + '">' +
        esc(g.label) + (n ? ' <span class="macf-n">' + n + '</span>' : '') +
        ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>' +
        '<div class="macf-panel" id="macf-g-' + g.id + '" data-macf-panel data-macf-label="' + esc(g.label) + '" hidden>';
      g.values.forEach(function (v) {
        var checked = (s[g.id] || []).indexOf(v[0]) >= 0;
        html += '<label class="macf-opt"><input type="checkbox" data-macf-cb data-g="' + g.id + '" value="' + esc(v[0]) + '"' +
          (checked ? ' checked' : '') + '><span class="macf-box">' +
          '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.5l4 4 8-9"/></svg>' +
          '</span><span class="macf-lab">' + esc(v[0]) + '</span><span class="macf-c">' + v[1] + '</span></label>';
      });
      html += '</div></div>';
    });
    groupsEl.innerHTML = html;
    groupsEl.hidden = false;

    /* 11 Sep 2026 (Claude): listen on the form, not groupsEl. On phones toSheet() moves the
       checkboxes into the bottom sheet, outside groupsEl, so ticks there never filtered anything. */
    form.addEventListener('change', function (e) {
      var cb = e.target.closest('[data-macf-cb]');
      if (!cb) return;
      var k = cb.getAttribute('data-g'), v = cb.value, st = state();
      if (cb.checked) { if (st[k].indexOf(v) < 0) st[k].push(v); }
      else { st[k] = st[k].filter(function (x) { return x !== v; }); }
      setState(st); apply();
    });
    groupsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-macf-toggle]');
      if (!btn) return;
      e.stopPropagation();
      var pan = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      groupsEl.querySelectorAll('[data-macf-panel]').forEach(function (p) { p.hidden = true; });
      groupsEl.querySelectorAll('[data-macf-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      btn.setAttribute('aria-expanded', String(!open));
      pan.hidden = open;
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-macf-pop]')) {
        groupsEl.querySelectorAll('[data-macf-panel]').forEach(function (p) { p.hidden = true; });
        groupsEl.querySelectorAll('[data-macf-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
    });
  }

  var sortSel = form.querySelector('[data-macf-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function (e) {
      if (anyActive(state())) { e.stopPropagation(); e.preventDefault(); apply(); }
    }, true);
  }

  grid.addEventListener('click', function (e) {
    var c = e.target.closest('[data-ga-item]');
    if (!c) return;
    var dl = window.dataLayer = window.dataLayer || [];
    var p = { item_list_name: document.title, items: [{ item_id: c.getAttribute('data-sku') || undefined, item_name: c.getAttribute('data-name') }] };
    dl.push({ event: 'select_item', ecommerce: p });
    if (typeof window.gtag === 'function') window.gtag('event', 'select_item', p);
  });

  /* Mobile: relocate the same panels into a bottom sheet rather than rendering a second copy,
     so checkbox state can never desync between two sets of inputs. */
  var sheet = form.querySelector('[data-macf-sheet]'),
      sbody = form.querySelector('[data-macf-sbody]'),
      scrim = form.querySelector('[data-macf-scrim]'),
      mq = window.matchMedia('(max-width:860px)'), moved = false;

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    var hadFocus = sheet.contains(document.activeElement);
    scrim.classList.remove('is-open'); sheet.classList.remove('is-open');
    document.body.style.overflow = '';
    var b = form.querySelector('[data-macf-open]'); if (b) { b.setAttribute('aria-expanded', 'false'); if (hadFocus) { try { b.focus({ preventScroll: true }); } catch (e) {} } }
    setTimeout(function () { if (!sheet.classList.contains('is-open')) { sheet.hidden = true; scrim.hidden = true; } }, 240);
  }
  /* 11 Sep 2026 (Claude): a tap on Filters before the product list has loaded opened an empty
     sheet. Start the load if needed and open once the groups exist. */
  function openSheet() {
    if (!sheet) return;
    if (!built) { start().then(showSheet, showSheet); return; }
    showSheet();
  }
  function showSheet() {
    if (!sheet) return;
    scrim.hidden = false; sheet.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('is-open'); sheet.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    var b = form.querySelector('[data-macf-open]'); if (b) b.setAttribute('aria-expanded', 'true');
    /* 11 Sep 2026 (Claude): move focus into the sheet on open; closeSheet hands it back to the Filters button. */
    var x = sheet.querySelector('[data-macf-close]'); if (x) { try { x.focus({ preventScroll: true }); } catch (e) {} }
  }
  function toSheet() {
    if (moved || !sbody || !groupsEl) return;
    groupsEl.querySelectorAll('[data-macf-pop]').forEach(function (pop) {
      var pan = pop.querySelector('[data-macf-panel]'); if (!pan) return;
      var g = document.createElement('div'); g.className = 'macf-sgroup';
      var h = document.createElement('h3'); h.textContent = pan.getAttribute('data-macf-label') || '';
      g.appendChild(h); pan.hidden = false; g.appendChild(pan); sbody.appendChild(g);
    });
    moved = true;
  }
  function fromSheet() {
    if (!moved || !groupsEl) return;
    groupsEl.querySelectorAll('[data-macf-pop]').forEach(function (pop) {
      var t = pop.querySelector('[data-macf-toggle]'); if (!t) return;
      var pan = document.getElementById(t.getAttribute('aria-controls'));
      if (pan) { pan.hidden = true; pop.appendChild(pan); }
    });
    if (sbody) sbody.innerHTML = '';
    moved = false;
  }
  function syncSheet() { if (mq.matches) { toSheet(); } else { fromSheet(); closeSheet(); } }

  var openBtn0 = form.querySelector('[data-macf-open]');
  if (openBtn0) openBtn0.addEventListener('click', openSheet);
  form.querySelectorAll('[data-macf-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
  if (scrim) scrim.addEventListener('click', closeSheet);
  if (mq.addEventListener) mq.addEventListener('change', syncSheet); else if (mq.addListener) mq.addListener(syncSheet);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      /* 11 Sep 2026 (Claude): Escape also closes an open desktop filter popover and returns focus to its button. */
      var openT = groupsEl && groupsEl.querySelector('[data-macf-toggle][aria-expanded="true"]');
      if (openT) {
        groupsEl.querySelectorAll('[data-macf-panel]').forEach(function (p) { p.hidden = true; });
        groupsEl.querySelectorAll('[data-macf-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        try { openT.focus({ preventScroll: true }); } catch (err) {}
      }
      closeSheet();
      return;
    }
    if (e.key !== 'Tab' || !sheet || sheet.hidden || !sheet.classList.contains('is-open')) return;
    var f = Array.prototype.filter.call(sheet.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!sheet.contains(a)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });

  var started = null;
  function start() {
    if (started) return started;
    started = load().then(function (items) {
      if (!items || !items.length) return;
      buildUI(facets(items));
      syncSheet();
      if (anyActive(state())) apply();
    });
    return started;
  }

  if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2500 });
  else setTimeout(start, 1200);
  window.addEventListener('hashchange', function () { if (idx) apply(); });
})();